import template from './insurances.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    insurances: '<',
    assets: '<',
    assetCommitmentSchedules: '<',
    contacts: '<',
    workflow: '<',
    isAssetFinanceCommercial: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, helperService, insurancesService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.organizationCountry = '';
      ctrl.availableInsuranceTypes = [];
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.insurances = ctrl.insurances || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.assetCommitmentSchedules = ctrl.assetCommitmentSchedules || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.isAssetFinanceCommercial = ctrl.isAssetFinanceCommercial || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.availableInsuranceTypes = insurancesService.getInsuranceTypes({
          assets: ctrl.assets,
          assetCommitmentSchedules: ctrl.assetCommitmentSchedules,
          workflow: ctrl.workflow,
          isAssetFinanceCommercial: ctrl.isAssetFinanceCommercial
        });
        ctrl.isReady = true;
      };

      ctrl.insuranceAdd = (insuranceTypeToAdded) => {
        const insuranceType = insuranceTypeToAdded;
        delete insuranceType.isDisabled;
        insurancesService.insuranceAdd(ctrl.insurances, insuranceType, ctrl.contacts);
      };

      ctrl.insuranceDelete = (insurance) => {
        const idx = helperService.findIndexById(ctrl.insurances, insurance.id);
        if (idx > -1) {
          ctrl.insurances = insurancesService.insuranceDelete(ctrl.insurances, idx);
          ctrl.saveInsurances();
        }
      };

      ctrl.getLastIndex = (data, idType) => helperService.getLastIndex(data, idType);

      ctrl.canSeeInsuranceType = (insuranceType) =>
        insurancesService.canSeeInsuranceType(insuranceType);

      /*
       * Save insurances
       * --------------------------------------------------------------------------------
       */
      ctrl.saveInsurances = (insurance) => {
        if (insurance) {
          const idx = helperService.findIndexById(ctrl.insurances, insurance.id);
          if (idx > -1) {
            ctrl.insurances.splice(idx, 1);
            ctrl.insurances.splice(idx, 0, insurance);
          } else {
            ctrl.insurances.push(insurance);
          }
        }
        ctrl.onFinished({ insurances: ctrl.insurances });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
